module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/100_4-978e51b554db00a67e2796661b3526fe.jpg";